import React from 'react';
import TreeView from 'react-treeview';
import styles from './ParticipationsTree.module.css';

function NodeLabel({ children }) {
  return (
    <span>
      <strong className={styles.strong}>{children}</strong>
    </span>
  );
}

function renderNode({ children, id, name, note, archived }) {
  if (children.length === 0) {
    return (
      <div className="tree-view_leaf" key={id}>
        <NodeLabel>
          <span className={`${archived ? 'text-muted' : ''}`}>{name}</span>
          <span className="text-muted">{note}</span>
        </NodeLabel>
      </div>
    );
  }

  const nodeLabel = (
    <NodeLabel>
      <span className={`${archived ? 'text-muted' : ''}`}>{name}</span>
      <span className="text-muted">{note}</span>
    </NodeLabel>
  );

  return (
    <TreeView key={id} nodeLabel={nodeLabel}>
      {children.map(renderNode)}
    </TreeView>
  );
}

function ParticipationsTree({ entities }) {
  return entities.map(renderNode);
}

export default ParticipationsTree;
